export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14343.f87dbe0f.jpg";